import React from 'react';
import styled from 'styled-components/native';
import {useTheme} from 'styled-components';
import {Theme} from '../../theme/lightTheme';
import GenericButton from '../button';
import {ChipProps} from '../../interfaces/components/chip';
import {wdp} from '../../utils/responsive';
import {I18nManager} from 'react-native';

const Container = styled(GenericButton)`
  align-self: flex-start;
`;

/**
 * Chip component.
 *
 * @param selected
 * @param labelStyle
 * @param dynamicWidth
 * @param isLabelGradient
 * @param borderRadius
 * @param {ChipProps} props - The Chip component props.
 * @returns {React.ReactElement} The rendered Chip component.
 */
const Chip: React.FC<ChipProps> = ({
  selected = false,
  labelStyle = {},
  dynamicWidth = true,
  isLabelGradient,
  borderRadius,
  ...props
}): React.ReactElement => {
  const theme = useTheme() as Theme;
  return (
    <Container
      labelStyle={{
        fontFamily: I18nManager.isRTL
          ? theme.fonts.ar.regular
          : theme.fonts.en.regular,
        fontSize: theme.text.s7,
        color: selected
          ? theme.text.light
          : isLabelGradient
            ? undefined
            : theme.text.title,
        paddingHorizontal: wdp(5),
        ...labelStyle,
      }}
      outline={!selected}
      isSmall
      dynamicWidth={dynamicWidth}
      radius={borderRadius || 100}
      isLabelGradient={isLabelGradient}
      {...props}
    />
  );
};

export default Chip;
